// extracted by mini-css-extract-plugin
export default {"wrapper":"profile-orders_wrapper__bZlWB","title":"profile-orders_title__aVr+R","list":"profile-orders_list__0huAd"};